import React, { useState, useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./ReportClassTable.css";
import "./SencoStudentsResultsTable.css"; // Import the same CSS file for styling
import LiteracyObservationsModal from "./LiteracyObservationsModal";
import ReadingScoreNotesModal from "./ReadingScoreNotesModal";
import AdditionalNeedsModal from "./AdditionalNeedsModal";
import DetailsOfSetReceivedModal from "./DetailsOfSetReceivedModal";
import SencoSupportPlanModal from "./SencoSupportPlanModal";
import SencoAdditionalNeedsModal from "./SencoAdditionalNeedsModal";
import PlaceOnContinuumModal from "./PlaceOnContinuumModal";
import SetSencoEalModal from "./SetSencoEalModal";
import ConfirmationModal from "./ConfirmationModal";
import SetEalModal from "./SetEalModal";
import SetSetModal from "./SetSetModal";
import SetSetNameModal from "./SetSetNameModal";
import SetAttendanceAffectingScoresModal from "./SetAttendanceAffectingScoresModal";

import NoteModal from "./NoteModal";
import {
  upsertSencoReport,
  getSencoReportByStudentId,
  getNotes,
} from "../services/APIClient";
import SencoReportTableRow from "./SencoReportTableRow";
import PriorityConcernsModal from "./PriorityConcernsModal";
import ClassroomSupportPlanModal from "./ClassroomSupportPlanModal";

function SencoReportsClassTable(props) {
  const {
    students,
    showAtRiskOnly,
    setShowAtRiskOnly,
    teachers,
    teacherid,
    studentsReadingScore,
    classDetails,
    showSortedData,
  } = props;

  console.log(showAtRiskOnly, "SENCO");

  const dummyHeaderArray = [
    "Class",
    "SET",
    "Classroom Support Plan",
    "Details Of SET Received",
    "Priority Concerns",
    "Additional Needs",
    "Support Plan",
    "EAL",
    "Place on Continuum",
  ];

  console.log(teachers, "senco teachers");

  let className = classDetails.name;

  useEffect(() => {
    setCallClassName(className);
  });

  const [callClassName, setCallClassName] = useState("");

  const [showLiteracyModal, setShowLiteracyModal] = useState(false);
  const [showReadingScoreModal, setShowReadingScoreModal] = useState(false);
  const [showAdditionalNeedsModal, setShowAdditionalNeedsModal] =
    useState(false);
  const [showSupportPlanModal, setShowSupportPlanModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showEalModal, setShowEalModal] = useState(false);
  const [showSetModal, setShowSetModal] = useState(false);
  const [
    showAttendanceAffectingScoresModal,
    setShowAttendanceAffectingScoresModal,
  ] = useState(false);

  const [showDetailsOfSetReceivedModal, setShowDetailsOfSetReceivedModal] =
    useState(false);

  const [showPlaceOnContinuumModal, setShowPlaceOnContinuumModal] =
    useState(false);

  const [showPriorityConcernsModal, setShowPriorityConcernsModal] =
    useState(false);

  const [showSencoSupportPlanModal, setShowSencoSupportPlanModal] =
    useState(false);

  const [showClassroomSupportPlanModal, setShowClassroomSupportPlanModal] =
    useState(false);

  const [showSencoAdditionalNeedsModal, setShowSencoAdditionalNeedsModal] =
    useState(false);

  const [showSetSetNameModal, setShowSetSetNameModal] = useState(false);

  const [showSencoEalModal, setShowSencoEalModal] = useState(false);

  const [currentStudentName, setCurrentStudentName] = useState("");
  const [currentStudentId, setCurrentStudentId] = useState("");

  // State to hold selections
  const [readingScoreNotes, setReadingScoreNotes] = useState([]);
  const [literacyObservations, setLiteracyObservations] = useState("");
  const [additionalNeeds, setAdditionalNeeds] = useState([]);
  const [setReceived, setSetReceived] = useState([]);
  const [priorityConcerns, setPriorityConcerns] = useState([]);
  const [sencoSupportPlan, setSencoSupportPlan] = useState([]);
  const [placeOnContinuum, setPlaceOnContinuum] = useState([]);
  const [classroomSupportPlan, setClassroomSupportPlan] = useState(false);
  const [sencoAdditionalNeeds, setSencoAdditionalNeeds] = useState([]);
  const [sencoEal, setSencoEal] = useState(false);
  const [eal, setEal] = useState(false);
  const [set, setSet] = useState(false);
  const [setName, setSetName] = useState("");
  const [attendanceAffectingScores, setAttendanceAffectingScores] =
    useState(false);

  const [sortCriteria, setSortCriteria] = useState({
    field: "name",
    order: "asc",
  });
  const [sortedData, setSortedData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");

  const handleShowLiteracyModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowLiteracyModal(true);
  };

  const handleShowReadingScoreModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);

    setShowReadingScoreModal(true);
  };

  const handleShowAdditionalNeedsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowAdditionalNeedsModal(true);
  };

  const handleShowSencoAdditionalNeedsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSencoAdditionalNeedsModal(true);
  };

  const handleShowClassroomSupportPlanModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowClassroomSupportPlanModal(true);
  };

  const handleShowDetailsOfSetReceivedModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);

    setShowDetailsOfSetReceivedModal(true);
  };

  const handleShowPlaceOnContinuumModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);

    setShowPlaceOnContinuumModal(true);
  };

  const handleShowAttendanceAffectingScoresModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowAttendanceAffectingScoresModal(true);
  };

  const handleShowESetModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSetModal(true);
  };

  const handleShowEalModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowEalModal(true);
  };

  const handleShowSencoEalModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSencoEalModal(true);
  };

  const handleShowPriorityConcernsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowPriorityConcernsModal(true);
  };

  const handleShowSencoSupportPlanModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSencoSupportPlanModal(true);
  };

  const handleShowSetSetNameModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSetSetNameModal(true);
  };

  const handleCloseLiteracyModal = () => setShowLiteracyModal(false);
  const handleCloseReadingScoreModal = () => setShowReadingScoreModal(false);
  const handleCloseAdditionalNeedsModal = () =>
    setShowAdditionalNeedsModal(false);
  const handleCloseSupportPlanModal = () => setShowSupportPlanModal(false);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);
  const handleCloseEalModal = () => setShowEalModal(false);
  const handleCloseSetModal = () => setShowSetModal(false);
  const handleCloseAttendanceAffectingScoresModal = () =>
    setShowAttendanceAffectingScoresModal(false);
  const handleCloseDetailsOfSetReceivedModal = () =>
    setShowDetailsOfSetReceivedModal(false);

  const handleCloseSencoEalModal = () => setShowSencoEalModal(false);

  const handleClosePlaceOnContinuumModal = () =>
    setShowPlaceOnContinuumModal(false);

  const handleClosePriorityConcernsModal = () =>
    setShowPriorityConcernsModal(false);

  const handleCloseSencoSupportPlanModal = () =>
    setShowSencoSupportPlanModal(false);

  const handleCloseClassroomSupportPlanModal = () =>
    setShowClassroomSupportPlanModal(false);

  const handleCloseSencoAdditionalNeedsModal = () =>
    setShowSencoAdditionalNeedsModal(false);

  const handleCloseSetSetModal = () => setShowSetSetNameModal(false);

  const [lastSavedStudentId, setLastSavedStudentId] = useState();

  const initialState = {
    sencoAdditionalNeeds: [],
    sencoSupportPlan: [],
    sencoEal: false,
    classroomSupportPlan: false,
    setName: "",
    setReceived: [],
    priorityConcerns: [],
    placeOnContinuum: [],
  };

  const resetStateVariables = () => {
    if (currentStudentId !== lastSavedStudentId) {
      setSetName(initialState.setName);
      setSencoAdditionalNeeds(initialState.sencoAdditionalNeeds);
      setSencoSupportPlan(initialState.sencoSupportPlan);
      setSencoEal(initialState.sencoEal);
      setClassroomSupportPlan(initialState.classroomSupportPlan);
      setSetReceived(initialState.setReceived);
      setPriorityConcerns(initialState.priorityConcerns);
      setPlaceOnContinuum(initialState.placeOnContinuum);
    }
  };

  const getFilteredAndSortedStudents = () => {
    let filteredStudents = studentsReadingScore;

    // Filter the students if the 'At Risk' checkbox is selected
    if (showAtRiskOnly) {
      filteredStudents = filteredStudents.filter(
        (student) => student.readingScore > 0 && student.readingScore <= 40
      );
    }

    // Sort the filtered students based on the criteria (sorting logic)
    return sortStudents(filteredStudents, sortCriteria);
  };

  useEffect(() => {
    const filteredAndSortedStudents = getFilteredAndSortedStudents();
    setSortedData(filteredAndSortedStudents);
  }, [studentsReadingScore, showAtRiskOnly, sortCriteria]);

  const handleAtRiskFilterChange = (e) => {
    setShowAtRiskOnly(e.target.checked);
  };

  const handleConfirmChange = () => {
    console.log("Confirmation received, saving changes");
    handleSaveChanges();
    handleCloseConfirmationModal();
  };

  // Fetch JiSi Report when currentStudentId changes
  useEffect(() => {
    if (currentStudentId) {
      getSencoReportByStudentId(currentStudentId)
        .then((response) => {
          console.log("JiSi Report Data:", response);
          if (response && response.readingscorenotes !== undefined) {
            setReadingScoreNotes(response.readingscorenotes);
          }
          if (response && response.literacyobservations !== undefined) {
            setLiteracyObservations(response.literacyobservations);
          }
          if (response && response.additionalneeds !== undefined) {
            setAdditionalNeeds(response.additionalneeds);
          }
          if (response && response.supportplan !== undefined) {
            // setSupportPlan(response.supportplan);
          }
          if (response && response.eal !== undefined) {
            setEal(response.eal);
          }
          if (response && response.set !== undefined) {
            setSet(response.set);
          }
          if (response && response.attendanceaffectingscores !== undefined) {
            setAttendanceAffectingScores(response.attendanceaffectingscores);
          }
        })
        .catch((error) => console.error("Error fetching JiSi report:", error));
    }
  }, [currentStudentId]);

  useEffect(() => {
    const sortedStudents = sortStudents(studentsReadingScore, sortCriteria);
    setSortedData(sortedStudents);
  }, [studentsReadingScore, sortCriteria]);

  const sortStudents = (students, criteria) => {
    return [...students].sort((a, b) => {
      if (criteria.field === "name") {
        return criteria.order === "asc"
          ? a.name?.localeCompare(b.name)
          : b.name?.localeCompare(a.name);
      } else if (criteria.field === "readingScore") {
        let scoreA =
          a.readingScore === "No completed tasks" || a.readingScore === "NA"
            ? -1
            : Number(a.readingScore);
        let scoreB =
          b.readingScore === "No completed tasks" || b.readingScore === "NA"
            ? -1
            : Number(b.readingScore);
        return criteria.order === "asc" ? scoreA - scoreB : scoreB - scoreA;
      }
    });
  };

  const handleSortChange = (field) => {
    setSortCriteria((prev) => ({
      field,
      order: prev.field === field && prev.order === "asc" ? "desc" : "asc",
    }));
  };

  const getSortIcon = (field) => {
    if (sortCriteria.field === field) {
      return sortCriteria.order === "asc"
        ? process.env.PUBLIC_URL + "/assets/imgs/desc-icon-active.png"
        : process.env.PUBLIC_URL + "/assets/imgs/asc-icon-active.png";
    }
    return process.env.PUBLIC_URL + "/assets/imgs/asc-icon-default.png";
  };

  const getReadingScoreClass = (score) => {
    if (score === 0) {
      return "low-color";
    } else if (score > 0 && score <= 20) {
      return "low-color";
    } else if (score > 20 && score <= 40) {
      return "med-color";
    } else if (score > 40 && score <= 80) {
      return "noRisk-color";
    } else if (score >= 81 && score <= 100) {
      // Include 81 in high-color
      return "high-color";
    }
    return "";
  };

  const handleSaveChanges = () => {
    const reportData = {
      studentid: currentStudentId,
      teacherid: teacherid,
      classname: callClassName,
      setname: setName,
      classroomsupportplan: classroomSupportPlan,
      setreceived: setReceived,
      priorityconcerns: priorityConcerns,
      additionalneeds: sencoAdditionalNeeds,
      supportplan: sencoSupportPlan,
      eal: sencoEal,
      supportcontinuum: placeOnContinuum,
    };

    console.log("Saving report data:", reportData);

    if (currentStudentId) {
      setLastSavedStudentId(currentStudentId); // Update last saved student ID
      resetStateVariables();
      upsertSencoReport(reportData)
        .then((response) => {
          resetStateVariables();
          console.log("Upsert SENCO Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      console.error("Error: No student selected.");
    }
  };

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  const handlePrintAllNotes = async () => {
    const formatNote = (n, teachersList) => {
      const teacher = teachersList.find((t) => t.id === n.teacherid);
      const teacherName = teacher?.name || 'Unknown';
      const dateStr = new Date(n.date_created).toLocaleString('en-IE', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Europe/Dublin',
      });
      return `
        <div style="margin-bottom:12px; padding:10px 12px; border-left:3px solid #1a56db; background:#f8f9fa; border-radius:4px;">
          <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:6px;">
            <span style="font-size:11px; color:#666;">${teacherName} &bull; ${dateStr}</span>
          </div>
          <div style="font-size:13px; color:#333; white-space:pre-wrap;">${n.note_text}</div>
        </div>`;
    };

    // REMOVED NOTE TYPE FROM PRINTED NOTES AS PER FEEDBACK
    // <span style="font-size:11px; font-weight:bold; background:#1a56db; color:white; padding:2px 8px; border-radius:4px;">${n.note_type}</span>


    const classNotesRes = await getNotes('class', classDetails.id, 'SencoReportClassTable');
    const classNotes = classNotesRes.data || [];
    const className = classDetails?.name || '';
    let html = `<!DOCTYPE html><html><head><title>All Notes — ${className}</title></head>
      <body style="font-family:Arial,sans-serif;padding:32px;max-width:760px;margin:0 auto;color:#1f2937;">
        <h1 style="border-bottom:2px solid #1a56db;padding-bottom:8px;color:#1a56db;margin-bottom:4px;">${className} — All Notes</h1>
        <p style="color:#999;font-size:11px;margin-bottom:28px;">Printed: ${new Date().toLocaleString('en-IE', { timeZone: 'Europe/Dublin' })}</p>`;
    if (classNotes.length > 0) {
      html += `<h2 style="color:#333;margin-top:0;margin-bottom:12px;">Class Notes</h2>`;
      html += classNotes.map((n) => formatNote(n, teachers)).join('');
    } else {
      html += `<p style="color:#999;text-align:center;margin-top:48px;">No notes found for this class.</p>`;
    }
    html += '</body></html>';
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); printWindow.close(); }, 250);
  };

  return (
    <Row>
      <Col>
        <div>
          <Row className="mb-2 align-items-center justify-content-end">
            <Col className="col-auto" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: '2px solid #1a56db', borderRadius: '8px', padding: '4px 8px', backgroundColor: '#eef2ff', gap: '2px' }}>
                <NoteModal entityName={classDetails?.name} elementtype="class" elementid={classDetails.id} noteType="SencoReportClassTable" teacherid={teacherid} teachers={teachers || []} />
                <span style={{ fontSize: '10px', color: '#1a56db', fontWeight: '600', lineHeight: 1 }}>Notes</span>
              </div>
              {/* <button onClick={handlePrintAllNotes} style={{ background: 'none', border: '2px solid #1a56db', borderRadius: '8px', color: '#1a56db', fontSize: '12px', fontWeight: '600', padding: '4px 10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>Print All Notes</button> */}
            </Col>
          </Row>
          <Row className="mb-3 filter-row">
            <Col>
              <div className="float-left-container">
                <label className="label-style">Show only:</label>
                <input
                  type="radio"
                  id="all"
                  name="filter"
                  value="all"
                  className="radio-button-style input-margin"
                  checked={selectedFilter === "all"}
                  onChange={handleFilterChange}
                />
                <label htmlFor="all" className="label-style">
                  All
                </label>
                <input
                  type="radio"
                  id="setOnly"
                  name="filter"
                  value="setOnly"
                  className="radio-button-style input-margin"
                />
                <label htmlFor="setOnly" className="label-style">
                  Set only
                </label>
                <input
                  type="radio"
                  id="atRisk0to20"
                  name="filter"
                  value="atRisk0to20"
                  className="radio-button-style input-margin"
                  checked={selectedFilter === "atRisk0to20"}
                  onChange={handleFilterChange}
                />
                <label
                  htmlFor="atRisk0to20"
                  className="radio-label radio-label-red label-style"
                >
                  At risk 0-20%
                </label>
                <input
                  type="radio"
                  id="atRisk21to40"
                  name="filter"
                  value="atRisk21to40"
                  className="radio-button-style input-margin"
                  checked={selectedFilter === "atRisk21to40"}
                  onChange={handleFilterChange}
                />
                <label
                  htmlFor="atRisk21to40"
                  className="radio-label radio-label-yellow label-style"
                >
                  21-40%
                </label>
              </div>
            </Col>
          </Row>
          <div className="table-responsive-wrapper">
            <Table className="custom-table">
              <thead>
                <tr>
                  <th
                    className="table-header-cell"
                    onClick={() => handleSortChange("name")}
                  >
                    <div className="header-content">
                      <span>Student Name</span>
                      <img
                        className="sort-icon"
                        src={getSortIcon("name")}
                        alt="Sort"
                      />
                    </div>
                  </th>
                  <th
                    className="table-header-cell"
                    onClick={() => handleSortChange("readingScore")}
                  >
                    <div className="header-content">
                      Overall Standard Score vs Test
                      <img
                        className="sort-icon"
                        src={getSortIcon("readingScore")}
                        alt="Sort"
                      />
                    </div>
                  </th>
                  {dummyHeaderArray.map((header, index) => (
                    <th key={index} className="table-header-cell">
                      <div className="header-content">{header}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedData
                  .filter((student) => {
                    if (selectedFilter === "all") return true;
                    if (selectedFilter === "atRisk0to20")
                      return (
                        student.readingScore !== undefined &&
                        student.readingScore <= 20
                      );
                    if (selectedFilter === "atRisk21to40")
                      return (
                        student.readingScore !== undefined &&
                        student.readingScore > 20 &&
                        student.readingScore <= 40
                      );
                    return true;
                  })
                  .map((student) => (
                    <SencoReportTableRow
                      key={student.id}
                      student={student}
                      teachers={teachers}
                      teacherid={teacherid}
                      className={className}
                      setSetName={setSetName}
                      setName={setName}
                      currentStudentId={currentStudentId}
                      setCurrentStudentId={setCurrentStudentId}
                      dummyHeaderArray={dummyHeaderArray}
                      getReadingScoreClass={getReadingScoreClass}
                      handleSaveChanges={handleSaveChanges}
                      handleShowDetailsOfSetReceivedModal={
                        handleShowDetailsOfSetReceivedModal
                      }
                      handleShowSencoSupportPlanModal={
                        handleShowSencoSupportPlanModal
                      }
                      handleShowPlaceOnContinuumModal={
                        handleShowPlaceOnContinuumModal
                      }
                      handleShowLiteracyModal={handleShowLiteracyModal}
                      handleShowReadingScoreModal={handleShowReadingScoreModal}
                      handleShowEalModal={handleShowEalModal}
                      handleShowSetModal={handleShowESetModal}
                      handleShowAttendanceAffectingScoresModal={
                        handleShowAttendanceAffectingScoresModal
                      }
                      handleShowAdditionalNeedsModal={
                        handleShowAdditionalNeedsModal
                      }
                      handleShowPriorityConcernsModal={
                        handleShowPriorityConcernsModal
                      }
                      handleShowClassroomSupportPlanModal={
                        handleShowClassroomSupportPlanModal
                      }
                      handleShowSencoAdditionalNeedsModal={
                        handleShowSencoAdditionalNeedsModal
                      }
                      handleShowSetSetNameModal={handleShowSetSetNameModal}
                      handleShowSencoEalModal={handleShowSencoEalModal}
                      readingScoreNotes={readingScoreNotes}
                      setReadingScoreNotes={setReadingScoreNotes}
                      literacyObservations={literacyObservations}
                      additionalNeeds={additionalNeeds}
                      eal={eal}
                      set={set}
                      attendanceAffectingScores={attendanceAffectingScores}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
        <LiteracyObservationsModal
          show={showLiteracyModal}
          handleClose={handleCloseLiteracyModal}
          studentName={currentStudentName}
          literacyObservations={literacyObservations}
          setLiteracyObservations={setLiteracyObservations}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          getReport={getSencoReportByStudentId}
          upsertReport={upsertSencoReport}
        />
        <ReadingScoreNotesModal
          show={showReadingScoreModal}
          handleClose={handleCloseReadingScoreModal}
          studentName={currentStudentName}
          readingScoreNotes={readingScoreNotes}
          setReadingScoreNotes={setReadingScoreNotes}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          getReport={getSencoReportByStudentId}
          upsertReport={upsertSencoReport}
        />
        <AdditionalNeedsModal
          show={showAdditionalNeedsModal}
          handleClose={handleCloseAdditionalNeedsModal}
          studentName={currentStudentName}
          additionalNeeds={additionalNeeds}
          setAdditionalNeeds={setAdditionalNeeds}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          getReport={getSencoReportByStudentId}
          upsertReport={upsertSencoReport}
        />
        <DetailsOfSetReceivedModal
          show={showDetailsOfSetReceivedModal}
          handleClose={handleCloseDetailsOfSetReceivedModal}
          studentName={currentStudentName}
          setReceived={setReceived}
          setSetReceived={setSetReceived}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <PriorityConcernsModal
          show={showPriorityConcernsModal}
          handleClose={handleClosePriorityConcernsModal}
          studentName={currentStudentName}
          priorityConcerns={priorityConcerns}
          setPriorityConcerns={setPriorityConcerns}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <SencoSupportPlanModal
          show={showSencoSupportPlanModal}
          handleClose={handleCloseSencoSupportPlanModal}
          studentName={currentStudentName}
          sencoSupportPlan={sencoSupportPlan}
          setSencoSupportPlan={setSencoSupportPlan}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <PlaceOnContinuumModal
          show={showPlaceOnContinuumModal}
          handleClose={handleClosePlaceOnContinuumModal}
          studentName={currentStudentName}
          placeOnContinuum={placeOnContinuum}
          setPlaceOnContinuum={setPlaceOnContinuum}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <ClassroomSupportPlanModal
          show={showClassroomSupportPlanModal}
          handleClose={handleCloseClassroomSupportPlanModal}
          studentName={currentStudentName}
          classroomSupportPlan={classroomSupportPlan}
          setClassroomSupportPlan={setClassroomSupportPlan}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <SencoAdditionalNeedsModal
          show={showSencoAdditionalNeedsModal}
          handleClose={handleCloseSencoAdditionalNeedsModal}
          studentName={currentStudentName}
          sencoAdditionalNeeds={sencoAdditionalNeeds}
          setSencoAdditionalNeeds={setSencoAdditionalNeeds}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <SetSencoEalModal
          show={showSencoEalModal}
          handleClose={handleCloseSencoEalModal}
          studentName={currentStudentName}
          sencoEal={sencoEal}
          setSencoEal={setSencoEal}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <ConfirmationModal
          show={showConfirmationModal}
          handleClose={handleCloseConfirmationModal}
          studentName={currentStudentName}
          handleConfirmChange={handleConfirmChange}
          handleSaveChanges={handleSaveChanges}
        />
        <SetEalModal
          show={showEalModal}
          handleClose={handleCloseEalModal}
          studentName={currentStudentName}
          eal={eal}
          setEal={setEal}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
        />
        <SetSetNameModal
          show={showSetSetNameModal}
          handleClose={handleCloseSetSetModal}
          studentName={currentStudentName}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          setName={setName}
          setSetName={setSetName}
          teacherid={teacherid}
        />
        <SetSetModal
          show={showSetModal} // Correct the prop name
          handleClose={handleCloseSetModal} // Correct the close handler
          studentName={currentStudentName}
          set={set} // Correct state variable for SET
          setSet={setSet} // Correct setter function
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
        />
        <SetAttendanceAffectingScoresModal
          show={showAttendanceAffectingScoresModal} // Correct the prop name
          handleClose={handleCloseAttendanceAffectingScoresModal} // Correct the close handler
          studentName={currentStudentName}
          attendanceAffectingScores={attendanceAffectingScores} // Correct state variable for SET
          setAttendanceAffectingScores={setAttendanceAffectingScores} // Correct setter function
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
        />
      </Col>
    </Row>
  );
}

export default SencoReportsClassTable;
